import DestinationPreview from './DestinationPreview'

export default DestinationPreview
